import React, { useEffect, useRef, useState } from "react";
import { Icon } from "leaflet";
import { Map, TileLayer, Marker, Popup, Tooltip } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "react-leaflet-markercluster/dist/styles.min.css";
import { Col, Divider, Input, message, Modal, Row, Space, Spin } from "antd";
import { filterUnique, searchFields } from "../utils/Utils";
import { apiCall } from "../utils/Api";
import BusinessContactInfo from "../components/BusinessContactInfo";
import { CanadaFlagIcon, USFlagIcon } from "../utils/Icons";


// single icon
const singleMarkerIcon = new Icon({
    iconUrl: "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDM2NSA1NjAiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxnPjxwYXRoIGZpbGw9IiNGMTJBNDYiIGQ9Ik0xODIuOSw1NTEuN2MwLDAuMSwwLjIsMC4zLDAuMiwwLjNTMzU4LjMsMjgzLDM1OC4zLDE5NC42YzAtMTMwLjEtODguOC0xODYuNy0xNzUuNC0xODYuOSBDOTYuMyw3LjksNy41LDY0LjUsNy41LDE5NC42YzAsODguNCwxNzUuMywzNTcuNCwxNzUuMywzNTcuNFMxODIuOSw1NTEuNywxODIuOSw1NTEuN3ogTTEyMi4yLDE4Ny4yYzAtMzMuNiwyNy4yLTYwLjgsNjAuOC02MC44IGMzMy42LDAsNjAuOCwyNy4yLDYwLjgsNjAuOFMyMTYuNSwyNDgsMTgyLjksMjQ4QzE0OS40LDI0OCwxMjIuMiwyMjAuOCwxMjIuMiwxODcuMnoiLz48L2c+PC9zdmc+",
    iconSize: [18, 31],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
});

// cluster icon
const createClusterCustomIcon = (cluster) => {
    return new Icon({
        iconUrl: "data:image/svg+xml;base64,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",
        iconSize: [40, 40], // Make cluster icons bigger
        iconAnchor: [20, 40],
        className: 'custom-cluster-icon', // Optional for extra styling
    });
};


// Show list of cities + count or list of stores. Max 5 + show count of more...
function getTooltipContent(cluster) {
    const markers = cluster.getAllChildMarkers();
    const cityMap = {};
    markers.forEach((marker) => {
        const data = marker.options.data;
        if (!data) return;
        const { city, name } = data;
        if (!cityMap[city]) cityMap[city] = [];
        cityMap[city].push(name);
    });

    const cities = Object.keys(cityMap);
    if (cities.length > 1) {
        let more_cities = 0;
        if (cities.length > 5) { more_cities = cities.length - 5; }
        const ret = cities.slice(0, 5).map((r) => `${r} (${cityMap[r].length})`).join("<br />");
        return (more_cities) ? ret + `<br>${more_cities} more...` : ret;
    } else {
        let more_stores = 0;
        if (cityMap[cities[0]].length > 5) { more_stores = cityMap[cities[0]].length - 5; }
        const city_ret = cityMap[cities[0]].slice(0, 5).join("<br />");
        return (more_stores) ? city_ret + `<br>${more_stores} more...` : city_ret;
    }
}

// cluster tooltip - groups + adds tooltip
function ClusterTooltipHandler({ clusterGroupRef }) {
    useEffect(() => {
        if (!clusterGroupRef.current) return;

        clusterGroupRef.current.leafletElement.on("clustermouseover", (event) => {
            const cluster = event.layer;
            const html = getTooltipContent(cluster);
            cluster.bindTooltip(html, {
                permanent: false,
                direction: "top",
                offset: [1, -35],
                opacity: 0.9,
            }).openTooltip();
        });
    }, [clusterGroupRef]);

    return null;
}


export default function FindABookstore(props) {
    const { content = {} } = props;
    const { container = true, data = {} } = content;
    const [loading, setLoading] = useState();
    const [storesList, setStoresList] = useState([])

    // sidebar sticky
    const stickyRef = useRef();
    const [style, setStyle] = useState({});
    const offset_top = 120;
    const offset_bottom = 20;

    //cluster
    const clusterGroupRef = useRef();
    const mapRef = useRef();

    // list 
    const [active, setActive] = useState('');
    const refs = useRef({});

    const [tab, setTab] = useState("map");
    const [filters, setFilters] = useState({
        region: "",
        search: ""
    })

    const locs = searchFields(storesList, filters?.search, ["name", "province", "prov", "metro", "city", "phone", "postal"]).filter(item => {
        const hasValidLat = !isNaN(parseFloat(item.lat_lng.lat));
        const matchesRegion = !filters.region || item.region === filters.region;
         return hasValidLat && matchesRegion;
    }).map(item => {
            return {
                region: item.region,
                province: item.province,
                name: item.name,
                city: item.city,
                url: item.url,
                position: [parseFloat(item.lat_lng.lat), parseFloat(item.lat_lng.lng)],
                data: item
            }
        });


    useEffect(() => {

        apiCall("findastore/get_stores", {}, (_s, _r) => {
            if (_s) {
                setStoresList(_r);
            } else {
                message.error(_r.error)
            }
            setLoading(false)
        })
    }, [])

    function fitMapToMarkers(locations = locs) {
        if (!mapRef.current || locations.length === 0) return;
        const map = mapRef.current.leafletElement;
        const bounds = L.latLngBounds(locations.map(loc => loc.position));
        map.fitBounds(bounds, { padding: [50, 50] });
    }
    useEffect(fitMapToMarkers, [locs])


    

    const drawMap = () => {
        return (
            <Map  center={[44.4809746, -96.5725433]} ref={mapRef} zoom={4} style={{ height: "600px", width: "100%", zIndex: "10" }}>
                <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {/* V1 had clusters, Trevor asked to be removed - might need again...
                    <MarkerClusterGroup
                    ref={clusterGroupRef}
                    showCoverageOnHover={false}
                    iconCreateFunction={(cluster) => {
                        const count = cluster.getChildCount();
                        return createClusterCustomIcon(cluster, count);
                    }}
                > */}
                {locs.map((loc) => (
                    <Marker onClick={() => {
                        console.log(mapRef.current.leafletElement.setView(loc.position, mapRef.current.leafletElement.getZoom()))
                    }}
                        key={loc.id} data={{ city: loc.city, name: loc.name }} position={loc.position} icon={singleMarkerIcon}>
                        <Tooltip
                            direction="top"
                            offset={[1, -35]}
                            opacity={0.9}
                            permanent={false}
                        >
                            {loc.name}
                        </Tooltip>
                        <Popup> <BusinessContactInfo data={loc.data} /></Popup>
                    </Marker>
                ))}
                {/* </MarkerClusterGroup> */}
                <ClusterTooltipHandler clusterGroupRef={clusterGroupRef} />
            </Map>
        )
    }

    const scrollTo = (selector, offset = 100) => {
        setActive(selector)
        window.scrollTo({
            behavior: 'smooth',
            top:
                refs.current[selector]?.getBoundingClientRect().top -
                document.body.getBoundingClientRect().top -
                offset,
        })
    }

    useEffect(() => {
        const onScroll = () => {
            // sidebar pinning
            if (stickyRef?.current) {
                const sticky = stickyRef.current;
                const parent = sticky.parentElement;
                const parentRect = parent.getBoundingClientRect();
                const stickyHeight = sticky.offsetHeight;
                if (parentRect.top - 100 < 0 && parentRect.bottom - offset_bottom > stickyHeight) {
                    // top
                    setStyle({
                        position: 'fixed',
                        top: offset_top,
                        width: sticky.offsetWidth,
                    });
                } else if (parentRect.bottom - offset_bottom <= stickyHeight) {
                    // bottom
                    setStyle({
                        position: 'absolute',
                        top: parent.scrollHeight - stickyHeight - offset_bottom,
                        width: '100%',
                    });
                } else {
                    // static
                    setStyle({
                        position: 'static',
                    });
                }
            }
            for (let key of locs) {
                const rect = refs.current[key.province]?.getBoundingClientRect();
                if (rect?.top <= 200 && rect.bottom >= 200) {
                    setActive(key.province);
                    break;
                }
            }
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, [locs]);


    const drawList = () => {
        const provinces = filterUnique(locs, "province");
        // split by countries
        const grouped = provinces.reduce((acc, prov) => {
            const region = prov.region;
            if (!acc[region]) acc[region] = [];
            acc[region].push(prov);
            return acc;
        }, {});

        const sortedRegions = Object.keys(grouped).sort();

        return (
            <Row>
                <Col span={5}>
                    <div style={style} ref={stickyRef}>
                        <div style={{ "padding": "0px 20px" }}>
                            {sortedRegions.map((region) => (
                                <div key={region}>
                                    <Divider style={{ "margin": "5px 0px" }} />
                                    {grouped[region]
                                        .sort((a, b) => a.province.localeCompare(b.province))
                                        .map((key) => (
                                            <div
                                                key={key.province}
                                                className={(active === key.province) ? "fab-anchor active" : "fab-anchor"}
                                                onClick={() => scrollTo(key.province)}
                                            >
                                                {key.province}
                                            </div>
                                        ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>
                <Col style={{ "padding": "0px 40px" }} span={19}>
                    {sortedRegions.map((region) => (
                        <div key={region}>
                            <div style={{ "textAlign": "center", "fontWeight": "bold", "color": "#1581E9", "fontSize": "35px" }}>{region}</div>
                            {grouped[region]
                                .sort((a, b) => a.province.localeCompare(b.province))
                                .map((key) => {
                                    const _stores = locs.filter(i => i.province === key.province);
                                    return (
                                        <div
                                            ref={el => (refs.current[key.province] = el)}
                                            key={key.province}
                                        >
                                            <div style={{ "fontWeight": "bold", "color": "#1581E9", "fontSize": "35px", "borderBottom": "1px solid #1581E9" }}>{key.province}</div>
                                            <div className="shim" />
                                            {_stores.map(_store => {
                                                return (
                                                    <div>
                                                        <Row gutter={20}>
                                                            <Col flex={"40%"}><strong style={{ "fontSize": "18px", "color": "#474747" }}>{_store.name}</strong></Col>
                                                            <Col flex={"20%"}><div style={{ "fontSize": "18px", "color": "#474747" }}>{_store.city}</div></Col>
                                                            <Col flex={"40%"}><a href={"//" + _store.url} target="_blank" className="blue-link" style={{ "fontSize": "18px" }}>{_store.url}</a></Col>
                                                        </Row>
                                                        <div className="shim" /><div className="shim" />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                })}
                        </div>
                    ))}
                </Col>
            </Row>
        );
    }




    const FIBSearch = (props) => {

        const [open, setOpen] = useState(false);
        const [txt, setTxt] = useState(filters.search)
        const inp = useRef(null);

        useEffect(() => {
            if (open && inp.current) {
                requestAnimationFrame(() => {
                    inp.current.focus();
                    inp.current.select();
                });
            }
        }, [open, inp]);




        return (
            <div>
                <Modal
                    open={open}
                    onCancel={() => setOpen(false)}
                    footer={null}
                    closeIcon={<></>}
                    centered
                    width={550}
                    mask={false}
                    maskClosable={true}
                >
                    <div style={{ "fontSize": "35px", "textAlign": "center" }}>Search for stores</div>
                    <div style={{ "fontSize": "18px", "textAlign": "center" }}>Try store name, city, state/province, or specialty ("kids")</div>
                    <div className="shim" /><div className="shim" />
                    <Input autoFocus ref={inp} onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setFilters({ ...filters, "search": txt })
                        }
                    }} defaultValue={filters.search} onChange={(e) => setTxt(e.target.value)} placeholder="Search..." />
                    <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />
                    <div style={{ "textAlign": "center" }}>
                        <Space size={20}>
                            <div onClick={() => setFilters({ ...filters, "search": txt })} className="fab-toggle">Search</div>
                            <div onClick={() => setOpen(false)} className="fab-toggle">Cancel</div>
                        </Space>
                    </div>
                </Modal>
                <div onClick={() => setOpen(true)} className="fab-toggle">{(filters.search) ? filters.search : "Search for stores..."}</div>
            </div>
        )
    }


    return (
        <div className={container ? "preview-container" : ""}>
            <div style={{ "textAlign": "center", "position": "relative", "zIndex": "1" }}>
                <div onClick={() => setTab("map")} className={(tab === "map" ? "fab-btn fab-btn-active" : "fab-btn fab-btn-inactive")}><div className="shim" />View Map</div>
                <div onClick={() => setTab("list")} className={(tab !== "map" ? "fab-btn fab-btn-active" : "fab-btn fab-btn-inactive")}><div className="shim" />View List</div>
            </div>
            <div style={{ "border": "2px solid #1581E9" }}>
                <Spin spinning={loading}>
                    <div className="shim" /><div className="shim" /><div className="shim" />
                    <div style={{ "textAlign": "center" }}>
                        <Space size={20}>
                            <FIBSearch fit={fitMapToMarkers} />
                            <div onClick={() => setFilters({ ...filters, "region": "Canada" })} className={(filters?.region === "Canada") ? "fab-toggle active" : "fab-toggle"}>Canada <CanadaFlagIcon /></div>
                            <div onClick={() => setFilters({ ...filters, "region": "USA" })} className={(filters?.region === "USA") ? "fab-toggle active" : "fab-toggle"}>USA <USFlagIcon /></div>
                            <div onClick={() => setFilters({ ...filters, "region": "", "search": "" })} className={(filters?.region === "") ? "fab-toggle active" : "fab-toggle"}>Show All</div>
                        </Space>
                    </div>
                    <div className="shim" /><div className="shim" /><div className="shim" />
                    {(tab === "map" && drawMap())}
                    {(!loading && tab !== "map" && drawList())}
                    <div style={{ "textAlign": "center", "color": "#2a2a2a", "fontSize": "12px", "padding": "5px 0px" }}>
                        <div><em>* this is currently displaying Bookmanager software users only...</em></div>
                        <div><em>For a list that includes wholesalers, publishers, online subscribers, etc - please visit our Company Directory</em></div>
                    </div>
                </Spin>
            </div>
            <div className="shim" /><div className="shim" /><div className="shim" />
        </div>
    );
}
